import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { IconTextSection as Original } from 'components/organisms'
import { IconTextSectionSettings, IconTextSectionFloatingSettings } from './IconTextSectionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getTextEditor } from '../TextEditor'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { buttonItemParams } from '../Button'
import { iconTextCardItemParams } from '../IconTextCard'
import {
  layoutDefaultProps,
  layoutItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'

export const defaultProps = {
  ...layoutDefaultProps('lg', false),
  theme: 'light',
}

export const iconTextSectionItemParams = (enabled, id, blockProps, children) => ({
  ...layoutItemParams(blockProps),
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  description: getTextEditor(children?.[1], enabled),
  children: [
    { pk: id + '_buttons', children: getItemChildren(enabled, children?.[2], buttonItemParams) },
    {
      pk: id + '_cards',
      children: getItemChildren(enabled, children?.[3], iconTextCardItemParams),
    },
  ],
})

export const dynamicProps = []

export const IconTextSection: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-icon-text-section ${props.className}`}
      >
        <Original
          item={iconTextSectionItemParams(enabled, id, blockProps, children)}
          theme={blockProps.theme}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

IconTextSection.craft = withCraft({
  name: 'IconTextSection',
  defaultProps: defaultProps,
  settings: IconTextSectionSettings,
  floatingSettings: IconTextSectionFloatingSettings,
})
